if(!customElements.get('product-gallery')) {
  customElements.define(
    'product-gallery',
    class ProductGallery extends HTMLElement {
      #thumbsEl;
      #thumbsInstance;
      #sliderEl;
      #sliderInstance;
      #lastWindowWidth;
      #onResize;
      #slideToSelectedVariant;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#thumbsEl = this.querySelector('[data-thumbs]');
        this.#sliderEl = this.querySelector('[data-slider]');
        this.#lastWindowWidth = window.innerWidth;

        if(!this.#thumbsEl || !this.#sliderEl) return;

        this.mountThumbs();
        this.mountSlider();

        this.#onResize = this.onResize.bind(this);
        this.#slideToSelectedVariant = this.slideToSelectedVariant.bind(this);

        window.addEventListener('resize', this.#onResize);
        window.addEventListener('variant:changed', this.#slideToSelectedVariant);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.#onResize);
      }

      onResize() {
        const currentWidth = window.innerWidth;
        const update = window.innerWidth < 1280;

        const crossed1280 =
          (this.#lastWindowWidth < 1280 && currentWidth >= 1280) ||
          (this.#lastWindowWidth >= 1280 && currentWidth < 1280);

        if (crossed1280) {
          const activeSlide = this.#sliderInstance.activeIndex;
          this.#thumbsInstance.destroy(true, true);
          this.#sliderInstance.destroy(true, true);

          this.mountThumbs();
          this.mountSlider(activeSlide);
        }

        this.#lastWindowWidth = currentWidth;
      }

      slideToSelectedVariant(evt) {
        if(!this.#sliderInstance) return;
        const variantId = evt.detail;
        const slideIndex = this.#sliderInstance.slides.findIndex((s) => {
          return s.dataset.variantAttached === variantId;
        });
        this.#sliderInstance.slideTo(slideIndex ?? 0);
      }

      mountThumbs() {
        const options = {
          slidesPerView: 4,
          spaceBetween: 8,
          breakpoints: {
            990: {
              slidesPerView: 6,
              spaceBetween: 12
            },
            1280: {
              slidesPerView: "auto",
              direction: "vertical"
            }
          },
          watchSlidesProgress: true
        };

        
        this.#thumbsInstance = new Swiper(this.#thumbsEl, options);
      }

      mountSlider(initialSlide = 0) {
        const options = {
          slidesPerView: 1,
          spaceBetween: 0,
          initialSlide,
          thumbs: {
            swiper: this.#thumbsInstance
          }
        };

        
        this.#sliderInstance = new Swiper(this.#sliderEl, options);
      }
    }
  );
}